
import { AdItem, AdPerformance } from './types';

/**
 * Calculate performance trends for an ad based on its metrics
 */
export function getPerformanceTrend(performance: AdItem['performance']): AdPerformance | null {
  if (!performance) return null;
  
  // This is a placeholder implementation
  // In a real-world scenario, this would compare current versus previous period data
  const isPositive = Math.random() > 0.5;
  const changePercent = Math.floor(Math.random() * 25) + 1;
  
  return {
    trend: isPositive ? 'up' : 'down',
    changePercent,
    isPositive
  };
}
